import React from 'react';
import PropTypes from 'prop-types';
import SrBox from 'client/components/SrBox';
import SrFlex from 'client/components/SrFlex';
import SrText from 'client/components/SrText';

import SrButton, {
  SR_BUTTON_THEME_ADOBE_BLUE_BORDER_PROPERTY_DOCS,
  SR_BUTTON_THEME_ADOBE_BLUE_PROPERTY_DOCS,
} from 'client/components/SrButton/SrButton';

import './SrPropertySetupDocsItem.less';
import SrLink from '../SrLink/SrLink';

const SrPropertySetupDocsItem = ({
  icon,
  title,
  subtitle,
  downloadEnabled,
  handleDownload,
  editLink,
}) => {
  return (
    <div styleName="SrPropertySetupDocsItem" direction="col" align="center">
      <div styleName="mainContainer">
        <SrFlex align="center">
          <SrBox
            backgroundImage={`url(${icon})`}
            backgroundPosition="center"
            backgroundRepeat="no-repeat"
            width="35px"
            height="35px"
          />
          <SrText font="greycliff" fontSize="18px" weight="800" letterSpacing="0">
            {title}
          </SrText>
        </SrFlex>
        <div styleName="subtitleContainer">
          <SrText
            font="greycliff"
            fontSize="14px"
            color={downloadEnabled ? 'black' : 'grey'}
            letterSpacing="0"
          >
            {subtitle}
          </SrText>
        </div>
      </div>
      {downloadEnabled && (
        <SrButton
          theme={SR_BUTTON_THEME_ADOBE_BLUE_PROPERTY_DOCS}
          onClick={handleDownload}
          hasBoxShadow
        >
          Download
        </SrButton>
      )}
      {!downloadEnabled && (
        <SrLink to={editLink}>
          <SrButton theme={SR_BUTTON_THEME_ADOBE_BLUE_BORDER_PROPERTY_DOCS}>Edit</SrButton>
        </SrLink>
      )}
    </div>
  );
};

SrPropertySetupDocsItem.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  downloadEnabled: PropTypes.bool.isRequired,
  handleDownload: PropTypes.func.isRequired,
};

export default SrPropertySetupDocsItem;
